'use strict';

(function ($, FUNCTIONS) {
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';

	// ＜ルート設定対応＞要素が空だったら削除
	var removeElmIfEmpty = function removeElmIfEmpty() {
		$('.js-checkEmptyElm').each(function (idx, val) {
			if (!$(val).text().length) {
				$(val).remove();
			}
		});
	};
	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	var removeBlockIfListEmpty = function removeBlockIfListEmpty() {
		if ($('.js-checkEmptyList').length) {
			$('.js-checkEmptyList').each(function (idx, val) {
				if (!$(val).find('li').length) {
					$(val).parents('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	};
	var share = function share() {
		if ($('.mod-share').length) {
			var pageUrl = document.URL;
			var shareUrl = "";
			var sharePagetitle = document.title.replace('&', '＆');
			// facebook
			if ($('.mod-share ._facebook').length) {
				shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl;
				$('.mod-share ._facebook').attr('href', shareUrl);
			}
			// twitter
			if ($('.mod-share ._twitter').length) {
				shareUrl = 'https://twitter.com/share?text=' + encodeURI(sharePagetitle) + '&url=' + pageUrl;
				$('.mod-share ._twitter').attr('href', shareUrl);
			}
			// line
			if ($('.mod-share ._line').length) {
				shareUrl = 'https://social-plugins.line.me/lineit/share?url=' + pageUrl;
				$('.mod-share ._line').attr('href', shareUrl);
			}
		}
	};
	var tabchange = function tabchange() {
		$('.js-product-menu_tab').click(function () {
			var tabgroup = $('.js-product-menu_tabWrap');
			var tabBlockgroup = $('.js-product-menu_tab-blockWrap');
			var index = $(this).index();
			// console.log(index,'index');
			// カレント・表示すべて外す
			$('.js-product-menu_tab').removeClass('current');
			$('.js-product-menu_tab-block').addClass('di_none');
			// ボタンカレント表示
			for (var i = 0; i < tabgroup.length; i++) {
				tabgroup.eq(i).find('.js-product-menu_tab').eq(index).addClass('current');
			}
			// 該当ブロック表示表示
			tabBlockgroup.find('.js-product-menu_tab-block').eq(index).removeClass('di_none');
			// 選択後タブ切り替え先頭へスクロール
			var hash = '#js-product-menu_tab-head';
			var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;
			if ($(window).width() < 1024) {
				pos -= 50;
			} else {
				pos -= 110;
			}
			$('html,body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
		});
	};
	removeElmIfEmpty();
	removeBlockIfListEmpty();
	share();
	tabchange();
})(window.jQuery, window.FUNCTIONS);